<template>
  <div class="home not-select">
    <div class="home-container dragBox">
      <!--菜单-->
      <!-- <drag ref="leftBar" :mini='treeOpen'> -->
      <div class="left-bar dragLeft" :style="{ width: `${leftWidth + '%'}` }">
        <left-bar :open="treeOpen" ref="leftbar">
          <div class="toggle-btn" @click="toggleMenu">
            <span :class="{
              'el-icon-s-fold': treeOpen,
              'el-icon-s-unfold': !treeOpen,
            }"></span>
            <!--<span></span>收缩侧边栏按钮位置     -->
          </div>
        </left-bar>
      </div>
      <div class="resize" :class="{ disableDrag: !treeOpen }" title="收缩侧边栏">⋮</div>
      <!-- <div slot="drag-right"> -->
      <!-- 自定义部分 -->
      <div class="dragRight" ref="box">
        <div>
          <el-header class="title-header" :style="{ height: !treeOpen ? '0px' : '68px' }">
            <header-nav ref="header" v-show="treeOpen" style="flex: 1;" />
            <!-- <div class="el-icon-star ai-icon" @click="shrinkAi_drawer" v-show="treeOpen">
              <img src="../assets/ai-icon.png" width="48" alt="ai-icon" srcset="">
            </div> -->
          </el-header>
          <!--右边主体-->
          <div class="rightContent" ref="rightContent">
            <div class="page-tabs">
              <div style="flex-grow: 1;width: 0;">
                <el-tabs @tab-click="clickTab" @keydown.native.capture.stop.prevent :value="this.activedTab" type="card"
                  closable ref="tabs" @tab-remove="removeTab" class="tabs">
                  <el-tab-pane v-for="item in showTabs" :key="item.name" :label="item.title" :name="item.name" />
                </el-tabs>
              </div>
              <div style="flex-basis: 40px;">
                <div class="closeAllTab" @click="closeAllTab">
                  <p><i class="el-icon-circle-close closeIcon"></i></p>
                </div>
              </div>
            </div>

            <div style="display: flex;" class="box">
              <div class="left" v-show="browserShow" style="background: #fff" :key="rootId">
                <pro-tree ref="proTree" v-if="browserShow" @nodeClick="nodeClick" />
              </div>
              <div class="resize2" v-show="browserShow" title="收缩侧边栏">
                ⋮
              </div>
              <div class="right">
                <keep-alive :include="Show">
                  <router-view ref="tabContent" :key="routerKey" :changeValue="updateSimpleSearch" v-if="isRouterAlive"
                    @deletePage="deleteItem" @deletePro="deletePro" @projectChange="routerReload"
                    @getBrowserPage="browserPage" @projectStatusChange="refresh"></router-view>
                </keep-alive>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div>

      <el-drawer :visible.sync="Ai_drawer" :size="deawerWidth">
        <div style="padding: 0 15px;">
          <iframe src="http://222.92.30.140:8118" loading="lazy" frameborder="0" width="100%" height="600px"></iframe>
        </div>
      </el-drawer>

    </div>

    <div v-if="showMessage">
      <el-drawer :visible.sync="drawer" :size="deawerWidth">
        <messageBoard @closeBoard="closeChildBoard"></messageBoard>
      </el-drawer>

      <div class="message-board-shrink-button" @click="shrinkClick">
        <i class="el-icon-d-arrow-left"></i>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import proTree from "@/components/proTree";
import LeftBar from "./components/leftBar.vue";
import headerNav from "./components/headerNav.vue";
import messageBoard from "@/components/messageBoard.vue";
import { publicList } from "@/utils/publicstate";
import { CACHE_COMPlIST, ROUTE_KEY_LIST, PROJECTROUTE_LIST } from '@/utils/constants';
import { dragTo } from "@/utils/index";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      projectStatus: "projectWorkflow/getProjectInfo",
      projectEcrInfo: 'projectWorkflow/getCreateEcrInfo',
      rootId: 'project/getProjectRootId'
    }),
    // rootId() {
    //   // return this.$store.state.projectRootId
    //   return this.projectStatus.isRoot
    // },
    Show() {
      const includesList = this.$store.state.includesList;
      return includesList.join(",");
    },
    leftWidth() {
      return this.treeOpen ? 11 : 4;
    },
    reloadPage() {
      return this.$store.state.refresh;
    },

    showMessage() {
      const arr = window.sessionStorage.getItem("modules").split(",").map(Number);
      return arr.includes(this.Constants.licenseChat);
    },

    navItem() {
      return publicList().navList[0];
    },

    routerKey() {
      // return this.$route.query?.seekId || '';
      const { path, matched, query } = this.$route;
      const { hasSecondary, key } = this.getRoute(path);

      if (hasSecondary) {
        return key
      }
      const { id = "", seekId = "", subClassId = '' } = query;
      if (!seekId && !id) {
        return path
      }

      return (subClassId || hasSecondary) ? id + subClassId : id + seekId
    },
    showTabs() {
      return this.$store.getters.getShowingTabInHome;
    },
    delInfo() {
      return this.$store.state.delInfo;
    },
    activedTab() {
      return this.$store.getters.getActivedTabInHome;
    }
  },
  watch: {
    $route(to, from) {
      let arr = PROJECTROUTE_LIST;
      if (from.matched.some((i) => i.path == "/project")) {
        if (!to.matched.some((i) => i.path == "/project") && !to.query.rootId) {
          this.browserShow = false;
        }
      }
    },

    browserShow(e) {
      var left = document.getElementsByClassName("left");
      if (!e) {
        left[0].style.width = 0 + "px";
        // right[0].style.width = "calc(100% - 10px)";
      }
    },

    reloadPage: {
      handler(val) {
        this.routerReload();
        // this.$store.commit('setPageRefresh',false)
      },
    },
    delInfo(val) {
      this.deletePro(val)
    }

  },
  data() {
    return {

      updateSimpleSearch: "", //向子组件传送change信息
      isRouterAlive: true,


      treeOpen: true,
      loading: true,
      browserShow: false,
      // screenWidth: document.body.clientWidth,

      browserPageList: [],
      drawer: false,
      Ai_drawer: false
    };
  },
  components: {
    proTree,
    LeftBar,
    headerNav,
    messageBoard,
  },
  methods: {


    getRoute(e) {

      let hasSecondary = false, key = '';

      ROUTE_KEY_LIST.map(i => {
        if (e.toLowerCase().indexOf(i.toLowerCase()) != -1) {
          key = i;
          hasSecondary = true
        }
      })
      return { hasSecondary, key }
    },

    shrinkClick() {
      this.drawer = true;
    },
    shrinkAi_drawer() {
      this.Ai_drawer = true;
    },
    closeChildBoard(val) {
      if (val) {
        this.drawer = false;
      }
    },
    nodeClick(e) {
      if (!e) {
        this.browserShow = false;
        return false;
      }

      const { objId: id, objClass: classId, objSubClass: subClassId, title, rootId } = e;
      const obj = { id, classId, subClassId, title, rootId };
      this.getLink(obj);
      this.routerReload();

    },

    refresh(e) {
      this.getProjcetTreeKey();
    },
    getProjcetTreeKey() {
      return Date.parse(new Date());
    },
    browserPage(e) {
      this.projectTree = true;
      let n = this.treeOpen ? 800 : 0;

      setTimeout(() => {
        this.browserShow = true;
        var left = document.getElementsByClassName("left");

        left[0].style.width = 260 + "px";

        if (e) {

          if (!this.browserShow) {
            this.browserPageList.splice(this.browserPageList.indexOf(e.rootId), 1);
            return false;
          }
          this.browserPageList.push(e);
        }
      }, n);

      this.treeOpen && this.toggleMenu();
    },
    deleteItem(e) {
      if (e) {
        this.removeTab(this.activedTab);
      }
      this.getMenuList();
    },
    deletePro(val) {

      if (1 > 0) {
        this.removeTab(this.activedTab);
      }
      this.getMenuList();
    },

    closeAllTab() {
      this.$confirm(
        this.$t("message.confirm.closeAllTabs"),
        this.$t("message.tips.tip"),
        {
          confirmButtonText: this.$t("message.button.affirm"),
          cancelButtonText: this.$t("message.button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          var tabs = this.showTabs; //已存在的list数据
          var activeName = this.activedTab;
          if (tabs.length < 2) {
            this.$message({
              message: this.$t("message.tips.tab"),
              type: "warning",
            });
            return false;
          } else {
            let res = tabs.find((i) => i.name === activeName);
            this.$store.commit("clearShowingTabsInHome");
            this.$store.commit("setShowingTabsInHome", res);

            this.$message({
              type: "success",
              message: this.$t("message.tips.closeSucess"),
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("message.tips.cancel"),
          });
        });
    },
    navClick() {
      // this.num = i;

      this.$store.commit("setActivedTabInHome", this.navItem.name);
      this.$router.push(this.navItem.path);
    },

    clickTab: function (tab, e) {
      const item = this.showTabs[tab.index];
      const activePath = this.$store.state.showingTabsInHome[tab.index].path;

      if (this.$store.state.activedTabInHome == item.name) {
        return false;
      }
      if (item.path == activePath) {
        this.routerReload();
      }
      console.log({ tab, item });


      this.$router.push({
        path: item.path,
        query: item.query,
      });

      this.$store.commit("setActivedTabInHome", item.name);
      this.$store.commit("setPageRefresh");
    },

    loadObject(e) {
      const objectInfo = {
        //获取url参数
        baseClassId: e.type,
        value: e.id,
      };
      var loadObjectUrl = `/pmdm/search/byObjId${this.params(objectInfo)}`;
      if (objectInfo.baseClassId == this.Constants.projectBaseClassId) {
        loadObjectUrl = `/ppm/project/searchByObjId${this.params(objectInfo)}`;
      }
      axios.get(loadObjectUrl).then((res) => {
        const item = {
          ...res.data.object.objectID,
          name: res.data.object.objectName,
        };
        this.getLink(item);
        this.routerReload();
      });
      // .then();
    },

    routerReload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },

    async getMenuList() {
      const { data: res } = await this.$http.get("/pmdm/menus/tree");
      this.$store.commit("setMenuList", res.object.tree);
      this.$nextTick(() => {
        this.$refs.leftbar.loadData();
      });
    },

    toggleMenu() {
      this.treeOpen = !this.treeOpen;
    },

    removeTab(targetName) {
      const tabs = this.showTabs; //已存在的list数据

      const activeName = this.activedTab;
      let nextTab = {};
      const n = tabs.findIndex((i) => i.name == targetName);
      if (tabs.length < 2) {
        this.$message({
          message: this.$t("message.tips.tab"),
          type: "warning",
        });
        return false;
      }

      if (activeName === targetName && this.$store.state.pageChanged) {
        // this.$confirm("当前页面有未保存信息，确定离开么", "提示", {
        this.$confirm(
          this.$t("message.confirm.closeWithoutSave"),
          this.$t("message.tips.tip"),
          {
            confirmButtonText: this.$t("message.button.affirm"),
            cancelButtonText: this.$t("message.button.cancel"),
            type: "warning",
          }
        ).then(() => {
          this.$store.commit("setPageChanged", false);
          nextTab = tabs[n + 1] ?? tabs[n - 1];
          this.$store.commit("setActivedTabInHome", nextTab.name);
          let newTabs = tabs.filter((tab) => tab.name !== targetName);
          let targetTab = tabs.find((tab) => tab.name == targetName);
          if (nextTab.path == targetTab.path) {
            this.routerReload();
          }
          this.$store.commit("replaceShowingTabsInHome", newTabs);
          let nextPush = {
            path: nextTab.path,
            query: nextTab.query,
          };
          this.$router.push(nextPush);
        })
          .catch(() => {
            return;
          });
      } else {

        // const arr =
        if (CACHE_COMPlIST.includes(tabs[n].path)) {
          let a = tabs[n].path.slice(1);
          this.$store.commit("getIncludesListPop", a);
        }

        if (activeName === targetName) {
          nextTab = tabs[n + 1] ?? tabs[n - 1];
          this.$store.commit("setActivedTabInHome", nextTab.name);

          if (tabs[n].type === "folder") {
            this.browserShow = false;
          }
          const nextPush = {
            path: nextTab.path,
            query: nextTab.query,
          };
          this.$router.push(nextPush);
        }
        const newTabs = tabs.filter((tab) => tab.name !== targetName);
        this.$store.commit("replaceShowingTabsInHome", newTabs);

      }
    },

    dragControllerDiv() {
      const treeOpen = this.treeOPen;

      if (!this.treeOpen) {
        return
      }
      var resize = document.getElementsByClassName("resize");
      var left = document.getElementsByClassName("dragLeft");
      var right = document.getElementsByClassName("dragRight");
      var box = document.getElementsByClassName("dragBox");

      new dragTo({ left, right, resize, box, treeOpen })

    },

    dragControllerDiv2() {
      var resize = document.getElementsByClassName("resize2");
      var left = document.getElementsByClassName("left");
      var right = document.getElementsByClassName("right");
      var box = document.getElementsByClassName("box");
      new dragTo({ left, right, resize, box })
    },

    getChangeNumber() {
      axios.get("/pmdm/changes/loadMyWorkFlows?tableType=1").then((res) => {
        const num = res.data.object.table.rows.length;
        this.changeNumShow = !!num;
        this.changeNum = num;
      });
    },
  },
  mounted() {

    this.dragControllerDiv();
    this.dragControllerDiv2();

    const theme = window.sessionStorage.getItem('theme');
    console.log(theme);

    const themeColor = theme.indexOf('#') === -1 ? '#4b91ff' : theme
    document.getElementById('app').style.setProperty('--themeColor', themeColor)


    // //// // console.log(this.$refs.tabs);
    // const that = this;
    // window.onresize = () => {
    //   return (() => {
    //     window.screenWidth = document.body.clientWidth;
    //     that.screenWidth = window.screenWidth;
    //   })();
    // };
    // this.$nextTick(_ => {
    //   var left = document.getElementsByClassName("dragRight");
    //   left[0].style.width = 320 + 'px'
    // })
  },
  created() {
    this.getMenuList();
    if (this.$route.matched.length == 1) {
      this.navClick();
      this.$store.dispatch('setTabItem', this.navItem)
    }

    this.deawerWidth = document.body.clientWidth * 0.4 > 680 ? "40%" : "660px";
    this.$i18n.locale = window.localStorage.getItem("lang");

  },
  beforeCreate() {
  },
};
</script>
<style scoped>
.dragRight {
  flex: 1;
  width: calc(100vh - 220px);
}

.tree-bottom {
  position: absolute;
  bottom: 0px;
  height: 395px;
  overflow: hidden;
}

.left-bar {
  /* width: 260px; */
  /* width: auto !important; */
  height: 100vh;
  /* background-image: linear-gradient(#3ea4f9, #4588f9); */
  background: var(--themeColor);
  position: relative;
  overflow: hidden;
  overflow-y: auto;
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
  transition-property: width;
  flex-shrink: 0;
}

.left-pro {
  /* width: 160px; */
  margin: 0;
}

.top {
  /* width: 260px; */
  background-image: url(~@/assets/tree-top.png);
}

.header {
  height: 68px;
  background: #fff;
}

.title-header {
  width: 100%;
  height: 68px;
  display: flex;
  align-items: center;
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
  transition-property: height;
}

.ai-icon {
  width: 48px;
  height: 48px;
  /* background: salmon; */
  cursor: pointer;
  margin-right: 12px;
}

.page-tabs {
  background-color: #ebf0f4;
  display: flex;
  padding-top: 8px;
  /* box-shadow: -1px 2px 2px 2px rgba(0, 0, 0, 0.11); */
  align-items: center;
  box-sizing: border-box;
}


.closeAllTab {

  /* right: 3px;
        top: 5px; */
  /* height: 46px;
        line-height: 50px; */
  width: 40px;
  height: 42px;
  z-index: 100;
  cursor: pointer;
  text-align: center;
  margin-left: auto;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  justify-items: center;
  border-radius: 6px 6px 0 0;
  background: var(--themeColor);
  /* background-color: #3ea4f9; */
  /* chrome 10+, safari 5.1+ */
  /* background-image: -webkit-linear-gradient(180deg, #3ea4f9, #4588f9, #5c7c99); */
  /* firefox; multiple color stops */
  /* background-image: -moz-linear-gradient(180deg, #3ea4f9, #4588f9, #5c7c99); */
  /* ie10 */
  /* background-image: -ms-linear-gradient(180deg, #3ea4f9 0%, #4588f9 100%); */
  /* opera 11.1 */
  /* background-image: -o-linear-gradient(180deg, #3ea4f9, #4588f9); */
  /* 标准写法 */
  /* background-image: linear-gradient(180deg, #3ea4f9, #4588f9); */
}

.closeIcon {
  color: #fff;
  font-size: 18px;
}

.home {
  width: 100%;
  height: 100vh;
  overflow: hidden;

}

.rightContent {
  height: calc(100vh - 128px);
}

/* 拖拽相关样式 */
/*包围div样式*/
.disableDrag {
  pointer-events: none;
}

.box {
  /* width: 100%; */
  /* height: 96%; */
  /* margin: 1% 0px; */
  /* overflow: hidden; */
  /* display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: stretch;
  min-height: 90%; */
  /* overflow: auto; */
  /* box-shadow: -1px 2px 2px 3px rgba(0, 0, 0, 0.11); */
}

/*左侧div样式*/
.left {
  /* width: 0px; */
  background: #ffffff;
  /* flex-basis: 260px; */
}

/*拖拽区div样式*/
.resize {
  cursor: col-resize;
  float: left;
  position: relative;
  /* top: 45%; */
  width: 10px;
  flex-basis: 10px;
  background-color: #d6d6d6;
  /* background-color: #d6d6d6;
      border-radius: 5px; */
  /* width: 10px;
      max-width: 10px; */
  /* height: 100%;
      line-height: 100%; */
  /* height: calc(100% - 180px);
      line-height: 810px; */
  text-align: center;
  background-size: cover;
  background-position: center;
  /*z-index: 99999;*/
  font-size: 18px;
  color: white;
}

.resize2 {
  cursor: col-resize;
  float: left;
  position: relative;
  /* top: 45%; */
  width: 10px;
  flex-basis: 10px;
  background-color: #d6d6d6;
  /* background-color: #d6d6d6;
      border-radius: 5px; */
  /* width: 10px;
      max-width: 10px; */
  /* height: 100%;
      line-height: 100%; */
  /* height: calc(100% - 180px);
      line-height: 810px; */
  text-align: center;
  background-size: cover;
  background-position: center;
  /*z-index: 99999;*/
  font-size: 18px;
  color: white;
}




.right {
  /* float: left; */
  /* float: right; */
  /* width: calc(100% - 10px); */
  background: #fff;
  flex-grow: 1;
  overflow: auto;
  height: calc(100vh - 128px);
}

.home-container {
  width: 100%;
  height: 100%;
  overflow: auto;
  /* height: 100% !important; */
  /* overflow: hidden; */
  display: flex;
}

.toggle-btn {
  /* width: 28px;
  height: 28px; */
  font-size: 28px;
  /* line-height: 24px; */
  color: #fff;
  cursor: pointer;

}

.message-board-shrink-button {
  width: 20px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border-radius: 4px 0 0 4px;
  position: absolute;
  top: 50%;
  right: 0;
  margin-top: -40px;
  cursor: pointer;
  /* background: rgba(69,136,249,0.3); */
  background: #66b1ff;
  color: #fff;
  transition: 0.4s;
}

.message-board-shrink-button:hover {
  background: #4588f9;
  color: #fff;
}
</style>

<style>
.el-tabs--card>.el-tabs__header {
  border-bottom: 2px solid var(--themeColor) !important;
  background: #ebf0f4;
  /* margin-right: 40px; */
}

.el-tabs--card>.el-tabs__header .el-tabs__nav {
  background: #d2e3f5;
  border-bottom-color: var(--themeColor);
}

.el-tabs__item {
  background: #d2e3f5;
  border-left: 3px solid#eaeff3 !important;
  font-size: 16px !important;
  border-radius: 6px 6px 0 0 !important;
}

.el-tabs__item.is-active {
  color: #fff;
  background: var(--themeColor);
}

.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: var(--themeColor);
}

/* 为对应的路由跳转时设置动画效果 */
.el-tabs__header {
  margin: 0;
}

.el-table .el-table__body {
  cursor: pointer;
}

.el-header {
  background-color: #fff;
  /* display: flex; */
  color: #fff;
  font-size: 19px;

  padding: 0 !important;
  margin: 0 !important;
}
</style>
